import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const GlobalAudioControls = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState('Cosmic Harmony in A♭');
  const [volume, setVolume] = useState(75);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentTime, setCurrentTime] = useState('2:34');
  const [totalTime, setTotalTime] = useState('5:47');

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handleVolumeChange = (e) => {
    setVolume(parseInt(e.target.value));
  };

  const handleNext = () => {
    // Handle next track logic
    console.log('Next track');
  };

  const handlePrevious = () => {
    // Handle previous track logic
    console.log('Previous track');
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-audio-controls transition-all duration-300 ${isExpanded ? 'h-32' : 'h-16'}`}>
      <div className="glass bg-surface/95 backdrop-blur-cosmic border-t border-border">
        {/* Expanded Controls */}
        {isExpanded && (
          <div className="px-4 py-3 border-b border-border/50">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                {/* Astrological Context */}
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
                    <Icon name="Sparkles" size={16} color="white" />
                  </div>
                  <div>
                    <div className="text-xs font-caption text-text-secondary">Current Aspect</div>
                    <div className="text-sm font-mono text-accent">Venus ♂ Mars</div>
                  </div>
                </div>

                {/* Mixing Controls */}
                <div className="flex items-center justify-center space-x-4">
                  <div className="flex items-center space-x-2">
                    <Icon name="Waves" size={16} color="currentColor" />
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value="60"
                      className="w-16 h-1 bg-surface rounded-full appearance-none slider"
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="Zap" size={16} color="currentColor" />
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value="40"
                      className="w-16 h-1 bg-surface rounded-full appearance-none slider"
                    />
                  </div>
                </div>

                {/* Export Options */}
                <div className="flex items-center justify-end space-x-2">
                  <Button variant="ghost" iconName="Download" onClick={() => console.log('Export')}>
                    Export
                  </Button>
                  <Button variant="ghost" iconName="Share" onClick={() => console.log('Share')}>
                    Share
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Controls */}
        <div className="px-4 py-3">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between">
              {/* Track Info */}
              <div className="flex items-center space-x-3 flex-1 min-w-0">
                <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center animate-gentle-pulse">
                  <Icon name="Music" size={20} color="white" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-text-primary truncate">
                    {currentTrack}
                  </div>
                  <div className="text-xs text-text-secondary font-mono">
                    {currentTime} / {totalTime}
                  </div>
                </div>
              </div>

              {/* Playback Controls */}
              <div className="flex items-center space-x-2 mx-4">
                <Button
                  variant="ghost"
                  iconName="SkipBack"
                  onClick={handlePrevious}
                  className="w-8 h-8 p-0"
                />
                <Button
                  variant="primary"
                  iconName={isPlaying ? "Pause" : "Play"}
                  onClick={handlePlayPause}
                  className="w-10 h-10 p-0 rounded-full"
                />
                <Button
                  variant="ghost"
                  iconName="SkipForward"
                  onClick={handleNext}
                  className="w-8 h-8 p-0"
                />
              </div>

              {/* Volume & Expand */}
              <div className="flex items-center space-x-3">
                <div className="hidden md:flex items-center space-x-2">
                  <Icon name="Volume2" size={16} color="currentColor" />
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={volume}
                    onChange={handleVolumeChange}
                    className="w-20 h-1 bg-surface rounded-full appearance-none slider"
                  />
                </div>
                <Button
                  variant="ghost"
                  iconName={isExpanded ? "ChevronDown" : "ChevronUp"}
                  onClick={toggleExpanded}
                  className="w-8 h-8 p-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .slider::-webkit-slider-thumb {
          appearance: none;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #4A5FBF;
          cursor: pointer;
        }
        .slider::-moz-range-thumb {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #4A5FBF;
          cursor: pointer;
          border: none;
        }
      `}</style>
    </div>
  );
};

export default GlobalAudioControls;